<script setup lang="ts">
import Button from '@/components/ui/button/Button.vue'

const {
  onClick,
  buttonClass = '',
  customClass = ''
} = defineProps<{ onClick: () => void; buttonClass: string; customClass: string }>()
</script>

<template>
  <div
    :class="`desktop:mb-[46px] text-secondary flex w-full flex-col items-center justify-around gap-2 text-xs font-normal md:mb-[44px] ${customClass ?? ''}`"
  >
    <slot name="configurationTitle" />
    <Button
      variant="default2"
      :class="`desktop:mt-0 mt-4 mb-2 h-[40px] w-full self-center text-sm lg:max-w-[320px] ${buttonClass ?? ''}`"
      @click="onClick"
    >
      <slot>{{ $t('HomePage.button.QuickStart') }}</slot>
    </Button>
  </div>
</template>
